import {
  REQUEST_DB_REPORT_ITEM_DATA, RECEIVE_DB_REPORT_ITEM_DATA, INVALIDATE_DB_REPORT_ITEM_DATA
} from '../../actions/dbreport/ItemsAction';

const convertData = data => {
  const newData = data.map((data, index) => {
        var rObj = {};
        rObj.yymm = data.yymm.substr(0,4) + '-' + data.yymm.substr(4,2);
        rObj.register_cnt = data.register_cnt;
        return rObj;
      });

  newData.sort((a,b) => a.yymm > b.yymm);

  newData.reduce(function(acc, val, index) {
    newData[index].all_reg_cnt = acc + val.register_cnt;
    return acc + val.register_cnt;
  }, 0);
  
  return newData;
}

const itemRegister = (state = {
  isFetching: false,
  didInvalidate: true,
  data: [],
  isActivityUser: true
}, action)=> {
  switch(action.type){
    case INVALIDATE_DB_REPORT_ITEM_DATA:
      return { ...state,
        didInvalidate: true
      }
    case REQUEST_DB_REPORT_ITEM_DATA:
      return { ...state,
              isFetching: true,
              didInvalidate: false
            }
    case RECEIVE_DB_REPORT_ITEM_DATA:
      return { ...state,
        isFetching: false,
        didInvalidate: false,
        data: convertData(action.data),
        isActivityUser: action.isActivityUser,
        lastUpdated: action.receivedAt
      }
    default:
      return state;
  }
}

export default itemRegister;



// WEBPACK FOOTER //
// ./src/reducers/dbReport/itemRegister.js